export const environment = {
  production: false,
  localJson: false,
  //apiUrl: '/ogc',
  //apiUrl: 'http://ogc-stg.apllogistics.com'
  apiUrl: 'https://oceanguaranteed-stg.apllogistics.com'
  };
